{
  "search-join-attendee-submit-btn": "TERMINÉ",
  "go-to-package-btn": "Options d'achat",
  "done-exit-btn": "Terminé (Quitter le kiosque)",
  "title-select-package": "Sélectionnez un pack",
  "title-suggest-a-product": "Souhaitez-vous ajouter un autre produit à votre commande ?",
  "title-choose-a-product": "Choisissez un produit à ajouter à votre commande",
  "store-title": "Sélectionnez le produit que vous souhaitez acheter",
  "title-shopping-cart": "Panier",
  "select-images-notice-message": "Veuillez sélectionner les images que vous souhaitez imprimer.",
  "select-images-notice-ok": "OK",
  "confirm-change-img-btn": "OK, utiliser cette image",
  "select-image-title": "Photo de profil OCCO",
  "welcome-title": "Album photo",
  "welcome-event-list-label": "Liste des événements :",
  "welcome-item-count-label": "Nombre d'éléments :",
  "select-image-selection-title": "Sélectionnez ({{count}}) image(s)",
  "select-image-step-label": "Étape {{currentStep}} sur {{totalSteps}}",
  "select-image-for-product-text": "pour \"{{title}}\"",
  "select-image-next-btn": "Suivant ({{selectedCount}}/{{requiredCount}})",
  "select-image-clear-btn": "Effacer",
  "select-image-no-photos-message": "Aucune photo disponible",
  "select-image-no-uid-message": "Oups, un problème est survenu lors de la localisation de votre compte. Veuillez réessayer.",
  "select-image-unlock-notice-message": "Veuillez sélectionner les images que vous souhaitez déverrouiller.",
  "select-image-print-or-unlock-notice-message": "Veuillez sélectionner les images que vous souhaitez imprimer ou déverrouiller.",
  "select-image-addon-selection-title": "Sélectionner des images",
  "select-image-addon-done-count-btn": "Terminé ({{count}})",
  "select-image-no-compatible-image-message": "Aucune image compatible n'a été trouvée",
  "select-image-photo-limit-message": "Veuillez sélectionner {{count}} image(s) que vous souhaitez imprimer.",
  "welcome-gallery-title": "Mon album",
  "welcome-select-images-of-yourself-title": "Sélectionnez toutes les images de vous-même",
  "welcome-select-found-images-title": "Sélectionnez les photos à ajouter à votre galerie",
  "welcome-back-to-gallery-btn": "Retour à l'album",
  "checkout-subtotal-label": "Sous-total :",
  "checkout-taxes-label": "Taxes :",
  "checkout-total-label": "Total :",
  "checkout-btn": "Paiement",
  "checkout-add-on-btn": "+ AJOUTER UN ARTICLE",
  "checkout-add-product-btn": "Ajouter un produit",
  "checkout-empty-cart-message": "Le panier est vide",
  "checkout-promo-code-placeholder": "réservé au personnel",
  "checkout-invalid-promo-code-message": "Code promotionnel invalide ou expiré !",
  "checkout-discount-label": "Remise : {{title}}",
  "checkout-receipt-title": "Reçu",
  "checkout-receipt-product-label": "Produit",
  "checkout-receipt-unit-price-label": "Prix unitaire",
  "checkout-receipt-qty-label": "Qté",
  "checkout-receipt-amount-label": "Montant",
  "checkout-digital-package-upsell-message": "Souhaitez-vous ajouter<br>un pack numérique à votre<br>panier et obtenir l'accès à<br>tous vos fichiers numériques ?",
  "photo-plus-pass-required-message": "Oups, il semble que vous n'ayez pas encore de pass Photo+.<br><br>Obtenez-le maintenant pour accéder au contenu en haute résolution.",
  "photo-plus-valid-ticket-required-message": "Oups, il semble que vous n'ayez pas encore de billet valide pour votre visite du parc. Associez votre billet pour profiter de notre expérience Photo+.",
  "photo-plus-visit-availability-message": "Votre expérience Photo+ est disponible pendant votre visite à Genting SkyWorlds.",
  "checkout-other-products-upsell-message": "Souhaitez-vous ajouter un tirage à votre pack numérique ?",
  "checkout-delete-restriction-message": "Vous devez conserver au moins un pack dans votre panier si vous souhaitez acheter des articles supplémentaires. Si vous devez changer de pack, veuillez d'abord retirer tous les articles supplémentaires de votre panier.",
  "checkout-digital-package-duplicate-message": "Vous avez déjà un pack d'accès numérique dans votre panier.<br>Un nouveau pack ne peut pas être ajouté tant que l'actuel n'est pas supprimé ou acheté.",
  "welcome-print-modal-title": "Impression",
  "welcome-print-modal-text": "Votre ou vos photo(s) seront imprimées et remises à l'organisateur de votre événement.",
  "cancel-btn": "Annuler",
  "welcome-preview-modal-title": "Aperçu",
  "close-btn": "Fermer",
  "ok-btn": "OK",
  "back-btn": "Retour",
  "info-title": "Info",
  "apply-btn": "Appliquer",
  "clear-btn": "Effacer",
  "yes-btn": "Oui",
  "no-btn": "Non",
  "change-image-btn": "Changer l'image",
  "done-btn": "Terminé",
  "skip-btn": "Passer",
  "refresh-btn": "Actualiser",
  "exit-btn": "Quitter",
  "unsupported-picture-format-message": "Format d'image invalide ou non pris en charge",
  "welcome-alert-modal-title": "Titre de la fenêtre",
  "welcome-alert-modal-body-text": "Le texte du corps de la fenêtre s'affiche ici.",
  "welcome-alert-save-btn": "Enregistrer les modifications",
  "welcome-passcodes-modal-title": "Générer des codes d'accès",
  "welcome-passcodes-events-label": "Sélectionnez le ou les événements pour lesquels vous souhaitez générer des codes d'accès :",
  "welcome-passcodes-email-label": "Adresse e-mail pour recevoir les codes d'accès au format XLS :",
  "welcome-passcodes-count-label": "Nombre de codes d'accès à générer :",
  "welcome-passcodes-count-help": "Un nombre entre 1 et 200 000",
  "welcome-passcodes-prepaid-label": "Les détenteurs de ces cartes seront-ils considérés comme prépayés / VIP ? :",
  "welcome-passcodes-expiry-label": "L'accès au kiosque public doit expirer (minutes) (0 pour désactiver cette option) :",
  "welcome-passcodes-url-prefix-label": "Préfixe d'URL d'accès à l'album (par ex. https://nom-de-domaine.com) :",
  "welcome-passcodes-generate-btn": "Générer",
  "sharing-modal-title": "Partager des images",
  "sharing-tab-email": "E-mail",
  "sharing-tab-sms": "SMS",
  "sharing-email-name-placeholder": "Nom complet",
  "sharing-email-placeholder": "Adresse e-mail valide",
  "sharing-email-help-text": "Séparez plusieurs adresses e-mail à l'aide des touches point-virgule, virgule, espace et entrée.",
  "sharing-contact-phone-placeholder": "Numéro de téléphone",
  "sharing-company-placeholder": "Entreprise / Institution",
  "sharing-sms-name-placeholder": "Nom complet",
  "sharing-sms-phone-placeholder": "Numéro de téléphone valide",
  "sharing-privacy-link": "Politique de confidentialité",
  "sharing-privacy-prefix": "Votre vie privée est très importante pour nous, veuillez lire notre",
  "welcome-delete-modal-title": "Supprimer",
  "welcome-delete-modal-body": "Êtes-vous sûr de vouloir supprimer cette image de votre album ?",
  "welcome-delete-photo-confirmation-message": "Êtes-vous vraiment sûr de vouloir supprimer cette image de votre album ?",
  "welcome-delete-photo-keep-btn": "Conserver cette image !",
  "welcome-delete-photo-delete-btn": "Supprimer cette image de mon album",
  "welcome-delete-reason-not-mine-btn": "Oui. Cette image n'est pas la mienne",
  "welcome-delete-confirm-btn": "Supprimer",
  "welcome-selfie-modal-title": "Retrouver mes images par visage",
  "welcome-selfie-match-found-title": "Nous pensons vous avoir trouvé !",
  "welcome-selfie-match-found-confirm-message": "Appuyez sur vos images pour confirmer.",
  "welcome-selfie-capture-btn": "Cliquez ici",
  "welcome-delete-reason-dont-want-btn": "Oui. L'image est à moi, mais je n'en veux pas",
  "welcome-print-copy-count-label": "Sélectionnez le nombre d'exemplaires à imprimer",
  "catalog-select-product-package-title": "Sélectionnez le pack produit",
  "freedompay-offline-request-title": "Veuillez saisir l'identifiant de la demande de transaction hors ligne",
  "square-reader-access-token-title": "Veuillez saisir le jeton d'accès Square",
  "square-reader-pairing-code-title": "Veuillez utiliser ce code pour vous connecter à votre nouveau lecteur Square et cliquez sur OK une fois terminé.",
  "square-reader-still-unpaired-text": "Cet appareil n'est toujours pas appairé, veuillez utiliser le code pour vous connecter à votre nouveau lecteur Square.",
  "square-reader-security-note-title": "Veuillez noter les deux clés suivantes car elles ne seront pas enregistrées pour des raisons de sécurité",
  "storicard-invalid-code-text": "Code StoriCard invalide.",
  "header-menu-user-id-link": "ID utilisateur :",
  "countdown-time-up-text": "Temps écoulé !",
  "welcome-find-more-images-btn": "Trouver plus d'images",
  "welcome-select-images-btn": "Sélectionner des images",
  "welcome-selected-images-next-btn": "C'est bien moi sur ces ({{count}}) images, Suivant >",
  "welcome-invalid-attendee-id-message": "ID participant invalide.",
  "welcome-kiosk-time-expired-message": "Désolé, le temps d'accès au kiosque public a expiré",
  "welcome-grouping-error-message": "Le regroupement de comptes créés il y a plus de 3 jours n'est pas autorisé.",
  "confirm-btn": "Confirmer",
  "approved-btn": "Approuvé",
  "checkout-confirm-purchase-title": "Veuillez confirmer votre achat",
  "checkout-confirm-purchase-short-title": "Confirmer l'achat",
  "checkout-digital-access-summary": "Accès à toutes vos images numériques prises aujourd'hui",
  "checkout-and-text": "et",
  "checkout-print-count-summary": "{{count}} tirage(s)",
  "checkout-digitals-copy-message": "Souhaitez-vous avoir une copie de vos fichiers numériques ?<br> Au cas où vous égareriez votre carte.",
  "checkout-email-placeholder": "Votre e-mail",
  "checkout-email-or-phone-placeholder": "Votre e-mail ou votre numéro de téléphone US",
  "checkout-sms-agreement-label": "J'accepte de recevoir des messages de notification de Storibox au numéro de téléphone fourni ci-dessus. Je comprends que je recevrai des SMS contenant des mises à jour et des liens vers mes images. Des frais de données et de messagerie peuvent s'appliquer. Répondez STOP pour vous désinscrire.",
  "checkout-name-placeholder": "Votre nom",
  "checkout-cancel-transaction-btn": "Annuler la transaction",
  "checkout-employee-authorization-title": "Autorisation d'employé requise",
  "checkout-scan-employee-card-prefix": "Scannez votre carte d'employé lorsque la transaction pour",
  "checkout-transaction-complete-suffix": "est terminée",
  "checkout-unlock-code-error-message": "Le code d'autorisation de l'employé est invalide.",
  "checkout-printing-now-title": "Impression en cours",
  "checkout-prints-ready-message": "Vos tirages seront prêts dans une minute",
  "checkout-digitals-unlocked-message": "Vos photos numériques sont maintenant déverrouillées",
  "checkout-internal-error-title": "Désolé, erreur interne",
  "checkout-transaction-processed-title": "TRANSACTION TRAITÉE !",
  "checkout-register-receipt-qr-message": "Veuillez scanner le QR pour enregistrer votre e-mail afin de recevoir votre reçu numérique et le lien vers l'album !",
  "checkout-shop-more-btn": "Continuer les achats",
  "checkout-print-receipt-btn": "Imprimer le reçu",
  "checkout-paid-by-cash-label": "Payé en espèces",
  "checkout-paid-by-card-label": "Payé par carte",
  "checkout-draft-order-error-message": "La création de la commande brouillon a échoué.",
  "checkout-print-confirmation-message": "Si vous avez commandé des tirages, ils seront prêts dans une minute. Vous pouvez récupérer votre marchandise au comptoir de vente",
  "checkout-shopify-params-incomplete-message": "Les paramètres Shopify ne sont pas complets",
  "checkout-event-name-required-message": "eventName n'est pas fourni.",
  "payment-no-device-connected-message": "Aucun appareil n'est connecté.",
  "payment-ask-for-assistance-message": "Veuillez demander de l'aide.",
  "payment-square-checkout-creation-failed-message": "La demande de paiement a échoué. Veuillez réessayer plus tard.",
  "payment-square-checkout-status-check-failed-message": "La vérification du statut du paiement a échoué. Veuillez réessayer plus tard.",
  "payment-qr-title": "Payez depuis votre téléphone",
  "payment-qr-help-html": "<b>Rapide et facile :</b><br> Scannez le code QR ci-dessus et suivez les instructions à l'écran.",
  "payment-qr-transaction-progress-message": "Transaction en cours...",
  "payment-qr-failed-message": "Le paiement par QR a échoué. Veuillez vérifier la clé API et réessayer.",
  "payment-failed-message": "Le paiement a échoué. Veuillez réessayer plus tard.",
  "payment-failed-short-message": "Votre paiement a échoué.",
  "payment-use-pinpad-message": "Veuillez utiliser le terminal de paiement pour finaliser votre transaction ...",
  "payment-terminal-progress-message": "Transaction en cours. <br>Pour annuler, appuyez sur la flèche du terminal.",
  "payment-transaction-canceled-message": "Votre transaction a été annulée.",
  "payment-transaction-canceled-close-btn": "Retour",
  "payment-transaction-canceled-done-btn": "Accueil",
  "search-version-label": "kiosque v.{{version}}",
  "search-find-by-qr-btn": "Trouver par QR",
  "search-find-by-face-btn": "Trouver par visage",
  "search-scan-another-qr-placeholder": "Scanner un autre code QR",
  "search-scanned-attendee-label": "Scanné : {{attId}}",
  "search-qr-or-photos-not-found-message": "Code QR ou photos introuvables. Veuillez scanner à nouveau.",
  "scanning-qr-page-title": "Album photo",
  "photo-viewer-back-btn": "Retour à l'album"
}
